export abstract class TransformEventsNamesStrategyService {
  abstract transformEventsNames(eventToDataLayer: Object): Object;
}
